module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'dropdown choose-lang-box',
      {
        'white-theme': _vm.specialHeader
      },
      _vm.className ]
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown",
    attrs: {
      "href": "javascript:void(0)",
      "id": "current-lang",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentLang.text) + "\n        "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu language-ul",
    attrs: {
      "aria-labelledby": "current-lang"
    }
  }, _vm._l((_vm.languages), function(lang) {
    return _c('li', {
      key: lang.code,
      staticClass: "language-li",
      on: {
        "click": function($event) {
          return _vm.changeLang(lang)
        }
      }
    }, [_c('a', {
      staticClass: "a-language",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(lang.text))])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-882e760e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChooseLang.vue
// module id = 1364
// module chunks = 1